module.exports = __webpack_public_path__ + "img/jumia3.97b61529.svg";